import { render, staticRenderFns } from "./editImageSlim.vue?vue&type=template&id=0eb450e0"
import script from "./editImageSlim.vue?vue&type=script&lang=js"
export * from "./editImageSlim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports